import {NgModule} from '@angular/core';
import {CommonModule, LocationStrategy, PathLocationStrategy} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {OrderModule} from 'ngx-order-pipe';
import {AngularEditorModule} from '@kolkov/angular-editor';
// Prime
import {InputTextModule} from 'primeng/inputtext';
import {MultiSelectModule} from 'primeng/multiselect';
import {DropdownModule} from 'primeng/dropdown';
import {SlideMenuModule} from 'primeng/slidemenu';
import {CarouselModule} from 'primeng/carousel';
import {GalleriaModule} from 'primeng/galleria';
import {ButtonModule} from 'primeng/button';
import {CheckboxModule} from 'primeng/checkbox';
import {CardModule} from 'primeng/card';
import {TableModule} from 'primeng/table';
import {ToastModule} from 'primeng/toast';
import {CalendarModule} from 'primeng/calendar';
import {SliderModule} from 'primeng/slider';
import {ContextMenuModule} from 'primeng/contextmenu';
import {DialogModule} from 'primeng/dialog';
import {ProgressBarModule} from 'primeng/progressbar';
import {FileUploadModule} from 'primeng/fileupload';
import {ToolbarModule} from 'primeng/toolbar';
import {RatingModule} from 'primeng/rating';
import {RadioButtonModule} from 'primeng/radiobutton';
import {InputNumberModule} from 'primeng/inputnumber';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService, MessageService} from 'primeng/api';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {RippleModule} from 'primeng/ripple';
import {TooltipModule} from 'primeng/tooltip';
import {StepsModule} from 'primeng/steps';
import {ListboxModule} from 'primeng/listbox';
import {DataViewModule} from 'primeng/dataview';
import {PickListModule} from 'primeng/picklist';
import {SelectButtonModule} from 'primeng/selectbutton';
import {TabViewModule} from 'primeng/tabview';
import {TreeModule} from 'primeng/tree';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {MessageModule} from 'primeng/message';

// Material
import {MatCarouselModule} from '@ngmodule/material-carousel';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBadgeModule} from '@angular/material/badge';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatTabsModule} from '@angular/material/tabs';
// CDK
import {A11yModule} from '@angular/cdk/a11y';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {PortalModule} from '@angular/cdk/portal';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';
import {OverlayModule} from '@angular/cdk/overlay';
// Ngb
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
// Ngx
import {NgxPaginationModule} from 'ngx-pagination';
import {NgxColorsModule} from 'ngx-colors';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {ShareModule} from 'ngx-sharebuttons';
import { NgxMaterialRatingModule } from 'ngx-material-rating';
//
import {MainLayoutComponent} from './components/layouts/main-layout/main-layout.component';
import {SearchFilterPipe} from './pipes/search-filter.pipe';
import {HamburgerMenuComponent} from './components/partials/hamburger-menu/hamburger-menu.component';
import {HeaderComponent} from './components/partials/header/header.component';
import {FooterComponent} from './components/partials/footer/footer.component';
import {DiscountsFilterPipe} from './pipes/discounts-filter.pipe';
import {AlumnosGrupoService} from './services/alumnos_grupo/alumnos-grupo.service';
import {BecasService} from './services/becas/becas.service';
import {CarrerasService} from './services/carreras/carreras.service';
import {ContactoService} from './services/contacto/contacto.service';
import {CountryService} from './services/country/country.service';
import {CrmService} from './services/crm/crm.service';
import {CuotasService} from './services/cuotas/cuotas.service';
import {CursosService} from './services/cursos/cursos.service';
import {DescuentosService} from './services/descuentos/descuentos.service';
import {DocentesService} from './services/docentes/docentes.service';
import {DuracioncursosService} from './services/duracioncurso/duracioncursos.service';
import {GruposService} from './services/grupos/grupos.service';
import {IntentoCompraService} from './services/intento_compra/intento-compra.service';
import {LandingPageService} from './services/landing-page/landing-page.service';
import {LoginService} from './services/login/login.service';
import {OpenPopupService} from './services/open_popup/open-popup.service';
import {PaisesService} from './services/paises/paises.service';
import {SalonesService} from './services/salones/salones.service';
import {SearchService} from './services/search/search.service';
import {SendcuotasService} from './services/sendcuotas/sendcuotas.service';
import {EntradasService} from './services/entradas.service';
import { MaintenanceModeComponent } from './components/pages/maintenance-mode/maintenance-mode.component';
import { SubmenuComponent } from './components/partials/submenu/submenu.component';

//

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    MainLayoutComponent,
    SearchFilterPipe,
    HamburgerMenuComponent,
    DiscountsFilterPipe,
    MaintenanceModeComponent,
    SubmenuComponent,
   
  ],
  imports: [
    CommonModule,
    //
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    OrderModule,
    AngularEditorModule,
    //
    NgbModule,
    MatExpansionModule,
    MatCarouselModule.forRoot(),
    MatMenuModule,
    MatButtonModule,
    MatTabsModule,
    MatSidenavModule,
    MatFormFieldModule,
    A11yModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    OverlayModule,
    PortalModule,
    ScrollingModule,
    MatSelectModule,
    NgxPaginationModule,
    NgbModule,
    NgxColorsModule,
    NgxMatSelectSearchModule,
    ShareModule,
    NgxMaterialRatingModule,
    // prime
    InputTextModule,
    MultiSelectModule,
    DropdownModule,
    SlideMenuModule,
    CarouselModule,
    GalleriaModule,
    ButtonModule,
    CheckboxModule,
    TableModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    ContextMenuModule,
    DialogModule,
    ProgressBarModule,
    FileUploadModule,
    InputTextareaModule,
    ToolbarModule,
    RatingModule,

    RadioButtonModule,
    InputNumberModule,
    ConfirmDialogModule,
    CardModule,
    RippleModule,
    TooltipModule,
    StepsModule,
    DataViewModule,
    ListboxModule,
    PickListModule,
    SelectButtonModule,
    TabViewModule,
    TreeModule,
    ScrollPanelModule,
    ProgressSpinnerModule,
    MessageModule,
  ],
  exports: [
    HttpClientModule,
    MatExpansionModule,
    HeaderComponent,
    FooterComponent,
    MainLayoutComponent,
    SearchFilterPipe,
    HamburgerMenuComponent,
    DiscountsFilterPipe,
    ReactiveFormsModule,
    FormsModule,
    //
    NgbModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatTabsModule,
    MatSidenavModule,
    MatFormFieldModule,
    A11yModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    OverlayModule,
    PortalModule,
    ScrollingModule,
    MatSelectModule,
    NgxPaginationModule,
    NgbModule,
    NgxColorsModule,
    NgxMatSelectSearchModule,
    ShareModule,
    NgxMaterialRatingModule,
    // prime
    InputTextModule,
    MultiSelectModule,
    DropdownModule,
    SlideMenuModule,
    CarouselModule,
    GalleriaModule,
    ButtonModule,
    CheckboxModule,
    TableModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    ContextMenuModule,
    DialogModule,
    ProgressBarModule,
    FileUploadModule,
    InputTextareaModule,
    ToolbarModule,
    RatingModule,
    RadioButtonModule,
    InputNumberModule,
    ConfirmDialogModule,
    CardModule,
    RippleModule,
    TooltipModule,
    StepsModule,
    DataViewModule,
    ListboxModule,
    PickListModule,
    SelectButtonModule,
    OrderModule,
    AngularEditorModule,
    TabViewModule,
    TreeModule,
    ProgressSpinnerModule,
    MessageModule,
    MaintenanceModeComponent,
  ],
  providers: [
    {provide: LocationStrategy, useClass: PathLocationStrategy},
    MessageService,
    ConfirmationService,
    AlumnosGrupoService,
    BecasService,
    CarrerasService,
    ContactoService,
    CountryService,
    CrmService,
    CuotasService,
    CursosService,
    DescuentosService,
    DocentesService,
    DuracioncursosService,
    GruposService,
    IntentoCompraService,
    LandingPageService,
    LoginService,
    OpenPopupService,
    PaisesService,
    SalonesService,
    SearchService,
    SendcuotasService,
    EntradasService,
  ]
})
export class SharedModule {
}
